import { render, staticRenderFns } from "./CookieSettingsItems.vue?vue&type=template&id=4be722bf"
import script from "./CookieSettingsItems.vue?vue&type=script&lang=js"
export * from "./CookieSettingsItems.vue?vue&type=script&lang=js"
import style0 from "./CookieSettingsItems.vue?vue&type=style&index=0&id=4be722bf&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports